<div>
  <div *ngIf="relationshipcount">
    <div class="dashboard-grid-container">
      <div class="dashboard-grid-item">
        <app-component-dashboard-item label="Total # of Relationships"
                                  value="{{relationshipcount.uniqueRelationshipCount}}"></app-component-dashboard-item>
      </div>
      <div *ngIf="isAdmin" class="dashboard-grid-item">
        <app-component-dashboard-item label="Total # of Bi-Directional Relationships"
                                  value="{{relationshipcount.biDiretionalRelationshipCount}}"></app-component-dashboard-item>
      </div>
      <div *ngIf="isAdmin" class="dashboard-grid-item">
        <app-component-dashboard-item label="Total # of Derived Relationships"
                                  value="{{relationshipcount.derivedSourceRelationshipCount}}"></app-component-dashboard-item>
      </div>
      <div *ngIf="isAdmin" class="dashboard-grid-item">
        <app-component-dashboard-item label="Total # of Differing UNSPSC"
                                  value="{{relationshipcount.differingUnspscCount}}"></app-component-dashboard-item>
      </div>
      <div class="dashboard-grid-item">
          <app-component-dashboard-item label="Last Refreshed Date"
                                    value="{{relationshipcount.lastRefreshedDate}}"></app-component-dashboard-item>
      </div>

    </div>
  </div>
</div>

